
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us-economy/us-housing-market",
      function () {
        return require("private-next-pages/us-economy/us-housing-market.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us-economy/us-housing-market"])
      });
    }
  